module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/ZW-a0abddfadf32c2622e54b972ad8e72cc.png";